<template>
    <div class="head-view">
        <div class="view-item" v-for="(item, i) in defaultdata" :key="i">
            <div class="view-val">{{ validDefaultData[i] }}</div>
            <div class="view-name">{{ item.value1 }}</div>
        </div>
    </div>
</template>

<script>
import * as methods from './method.js'
export default {
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            defaultdata: [
                { value1: '纳管总数', value2: '27785' },
                { value1: '扫码次数', value2: '9035' },
                { value1: '食品餐饮', value2: '3563' },
                { value1: '药品药店', value2: '42' },
                { value1: '特种设备', value2: '0' },
                { value1: '民宿酒店', value2: '468' },
                { value1: '学校机构', value2: '0' },
                { value1: '综合品类', value2: '23712' },
            ],
            valueMap: [
                { name: '名称', key: "value1" },
                { name: '数值', key: "value2" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            config: {
            },
            validDefaultData: [],
            numTotals: [],
            timers: []
        }
    },
    methods: {
        ...methods,
        setdata() {
            this.numTotals = []
            this.validDefaultData = []
            let vdata = JSON.parse(JSON.stringify(this.defaultdata))
            this.numTotals = vdata.map(item => item.value2)
            this.validDefaultData = vdata.map(item => {
                let vitem = ''
                for(let i = 0;i< item.value2.length;i++) {
                    vitem += '0'
                }
                return vitem
            })
            this.startNum()
        },
        numrise() {

        },
        startNum() {
            let samenum = 0
            this.numTotals.forEach((item, i) => {
                if (this.validDefaultData[i] == item) {
                    samenum += 1
                } else {
                    let vlist = this.validDefaultData[i].split('')
                    let vlist2 = item.split('')
                    let list3 = vlist.map((del, i) => {
                        if (+del < +vlist2[i]) {
                            del = +del + 1
                        }
                        return del
                    })
                    let vdel = list3.join('')
                    this.validDefaultData[i] = vdel
                }
            })
            this.validDefaultData = [...this.validDefaultData]
            if (samenum == this.numTotals.length) {
                setTimeout(() => {
                    this.setdata()
                }, 20000);
            } else {
                setTimeout(() => {
                    this.startNum()
                }, 200);
            }
        }
    },
    mounted() {
        this.setdata()
    }
}
</script>

<style lang="scss" scoped>
.head-view {
    width: 881px;
    height: 59px;
    background: url(@/assets/temimg15/view-bg.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 30px;
    .view-item{
        position: relative;
        margin-top: -24px;
        text-align: center;
        & + .view-item::after {
            content: "";
            position: absolute;
            left: -15px;
            width: 1px;
            height: 16px;
            background: rgba(90, 199, 255, .4);
            top: 8px;
        }
    }
    .view-val {
        font-family: 'pmzd';
        font-weight: 400;
        font-size: 22px;
        color: #00FFFF;
        line-height: 22px;
    }
    .view-name {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #C3DCFF;
        line-height: 14px;
        margin-top: 10px;
    }
}
</style>